import axios from "axios";

export const fetchMeeting = async (urlId) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE}/companion/meet-details/?url_id=${urlId}`
        );

        return response;
    } catch (error) {
        console.error(error);
    }
}
